





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISortParameters } from "@/interfaces";

@Component
export default class AppsDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public apps: any[] | null;

  get columns() {
    const columns = [
      {
        label: this.$t("PAGES.APPS.NAME"),
        field: "name",
        thClass: "start-cell",
        tdClass: "start-cell",
      },
      {
        label: this.$t("PAGES.DEV_TOOLS.URL"),
        field: "url",
        thClass: "hidden lg:table-cell",
        tdClass: "hidden lg:table-cell",
      },
      {
        label: this.$t("PAGES.DEV_TOOLS.STATUS"),
        field: "status",
        thClass: "end-cell text-center hidden lg:table-cell",
        tdClass: "end-cell text-center hidden lg:table-cell",
      },
    ];

    return columns;
  }

  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }
}
